import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NbAuthResult, NbAuthService } from "@nebular/auth";
import { NbToastrService } from "@nebular/theme";

@Component({
  selector: "app-reset-pass",
  templateUrl: "./reset-pass.component.html",
  styleUrls: ["./reset-pass.component.scss"],
})
export class ResetPassComponent implements OnInit {
  email: string;
  token: string;
  password: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: NbAuthService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.email = this.route.snapshot.paramMap.get("email");
    this.token = this.route.snapshot.paramMap.get("token");
  }

  resetPassword(): void {
    this.authService
      .resetPassword("email", {
        email: this.email,
        token: this.token,
        password: this.password,
      })
      .subscribe(
        (confirmed) => {
          if (confirmed) {
            this.toastrService.success(
              "Your operation was successful! Signin with your new password",
              "Success"
            );

            this.router.navigate(["/auth/login"]);
          } else {
            this.toastrService.danger("Your operation failed", "Error");
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
